import { jsx as _jsx } from "react/jsx-runtime";
import { useThree } from '@react-three/fiber';
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { xrSpaceContext } from './contexts.js';
import { useXR } from './xr.js';
/**
 * component for setting the origin of the player (their feet)
 */
export const XROrigin = forwardRef(({ children, ...props }, ref) => {
    const xrCamera = useThree((s) => s.gl.xr.getCamera());
    const internalRef = useRef(null);
    useImperativeHandle(ref, () => internalRef.current, []);
    const referenceSpace = useXR((xr) => xr.originReferenceSpace);
    useEffect(() => {
        const group = internalRef.current;
        if (group == null) {
            return;
        }
        group.add(xrCamera);
        return () => void group.remove(xrCamera);
    }, [xrCamera]);
    return (_jsx("group", { ref: internalRef, ...props, children: referenceSpace != null && _jsx(xrSpaceContext.Provider, { value: referenceSpace, children: children }) }));
});
